<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <!-- 订单 -->
          <el-form-item label="订单：" class="form-item-b0">
            <el-input
              v-model="query.search"
              placeholder="请输入订单"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>
          <el-button size="small" @click="init()">重置</el-button>
          <el-button type="success" size="mini" @click="onEditInfo">添加产品</el-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <!-- <ShowTableInfo :showItem="showItem" :list="list" :getListFn="getListFn" :param="query">
      <template slot="btn" slot-scope="scope">
        <el-button type="primary" size="mini" @click="onEditInfo(scope.data)"> 修改信息 </el-button>

        <el-button style="margin-top: 6px" type="danger" size="mini" @click="onDelete(scope.data.ProductId)">
          删除
        </el-button>
      </template>
    </ShowTableInfo> -->

    <el-table ref="TableListRef" class="TableList" border :data="list" v-loading="loading">
      <el-table-column type="expand">
        <template slot-scope="props">
          <ShowTableInfo
            :showPagination="false"
            :showItem="showItem"
            :list="list"
            :getListFn="getSpecListFn"
            listKey=""
            :param="{
              productId: props.row.ProductId
            }"
            paramChangeGetList
          >
            <template slot="btn" slot-scope="scope">
              <el-button type="primary" size="mini" @click="onEditSpec(scope.data)"> 修改信息 </el-button>

              <el-button
                style="margin-top: 6px"
                type="danger"
                size="mini"
                @click="onDeleteSpec(scope.data.ProductSpecId)"
              >
                删除
              </el-button>
            </template>
          </ShowTableInfo>
        </template>
      </el-table-column>

      <el-table-column prop="ProductId" label="Id" align="center"></el-table-column>

      <el-table-column prop="Name" label="名称" align="center"></el-table-column>

      <el-table-column prop="Title" label="标题" align="center"></el-table-column>

      <el-table-column prop="Integral" label="积分" align="center"></el-table-column>

      <el-table-column prop="Stock" label="库存" align="center"></el-table-column>

      <el-table-column prop="MaxCount" label="限购" align="center"></el-table-column>

      <el-table-column prop="Status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.Status"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="onStatus(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onAddSpec(scope.row.ProductId)"> 添加规格 </el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onEditInfo(scope.row)"> 修改信息 </el-button>

          <el-button style="margin-top: 6px" type="danger" size="mini" @click="onDelete(scope.row.ProductId)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[20, 40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 添加规格 -->
    <el-dialog
      :visible.sync="addDialog"
      class="FormDialogBox"
      width="80%"
      title="添加产品"
      :close-on-click-modal="false"
      append-to-body
      @close="addDialogClose"
    >
      <el-form label-width="auto" :model="addForm" ref="ruleForm">
        <el-form-item label="规格名称">
          <el-input v-model="addForm.specName" placeholder="规格名称">"></el-input>
        </el-form-item>

        <el-form-item label="编号">
          <el-input v-model="addForm.specCode" placeholder="编号">"></el-input>
        </el-form-item>

        <el-form-item label="价格">
          <el-input v-model="addForm.price" placeholder="价格"></el-input>
        </el-form-item>

        <el-form-item label="积分">
          <el-input v-model="addForm.integral" placeholder="积分"></el-input>
        </el-form-item>

        <!-- <el-form-item label="运费">
          <el-input v-model="addForm.freight" placeholder="运费"></el-input>
        </el-form-item> -->

        <el-form-item label="库存">
          <el-input v-model="addForm.stock" placeholder="库存"></el-input>
        </el-form-item>

        <el-form-item label="限购">
          <el-input v-model="addForm.maxCount" placeholder="限购"></el-input>
        </el-form-item>

        <el-form-item label="排序">
          <el-input v-model="addForm.sort" placeholder="排序"></el-input>
        </el-form-item>

        <el-form-item label="图片">
          <el-upload
            ref="upload"
            action="https://api.chajiuqu.com/api/current/uploadimage"
            list-type="picture-card"
            :file-list="myImage2"
            multiple
            accept="image"
            :limit="1"
            :on-preview="handlePictureCardPreview"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="状态">
          <el-switch
            v-model="addForm.status"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogClose">取 消</el-button>
        <el-button type="danger" @click="addDetermine()"> 确 定 </el-button>
      </div>
    </el-dialog>

    <div class="pre_img" v-if="dialogVisible">
      <i class="el-icon-circle-close icon" @click="imgClose"></i>
      <el-image class="img" style="width: 20%; display: block; margin: 0 auto" :src="dialogImageUrl"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: 'membersIndex',

  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,

      list: [],

      addDialog: false,
      addForm: {},

      loading: true,
      total: 0,

      query: {
        pageindex: 1,
        pagesize: 20,
        categorize: 1,
        search: ''
      },

      showItem: [
        {
          prop: 'SpecName',
          label: '规格名称'
        },
        {
          prop: 'SpecCode',
          label: '编号'
        },
        {
          prop: 'Price',
          label: '价格'
        },
        {
          prop: 'Integral',
          label: '积分'
        },
        {
          prop: 'Stock',
          label: '库存'
        },
        {
          prop: 'MaxCount',
          label: '限购'
        }
      ]
    }
  },

  created() {
    console.log('goods')
    this.initAddForm()
    this.getList('place')
  },

  computed: {
    myImage: function () {
      const arr = []
      if (this.addForm.ImgUrl) {
        const list = this.addForm.ImgUrl.split(',')
        list.forEach((item) => {
          if (item) {
            arr.push({
              url: item
            })
          }
        })
      }
      return arr
    },

    myImage2: function () {
      const arr = []
      if (this.addForm.imgUrl) {
        arr.push({
          url: this.addForm.imgUrl
        })
      }
      return arr
    }
  },

  methods: {
    initAddForm() {
      this.addForm = {
        id: 0,
        productId: 0,
        specName: '',
        specName2: '',

        imgUrl: '',

        specCode: '',
        price: '',
        integral: '',

        // freight: '',
        stock: 0,
        maxCount: 0,

        sort: 1,

        status: 1
      }
    },

    getListFn(query) {
      return this.$api.integral.list(query)
    },

    getSpecListFn(query) {
      return this.$api.integral.specList(query)
    },

    // 获取列表
    async getList(place) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        await this.$nextTick()
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      }

      console.log(this.query)

      try {
        const { data: res } = await this.$api.integral.list(this.query)
        console.log('获取订单列表', res)

        this.loading = false
        this.list = res.list
        this.total = res.count
      } catch (error) {
        console.log(error)
        this.$message.error('获取列表失败')
        this.loading = false
      }
    },

    async onStatus(from) {
      console.log(from)
      const query = {}
      for (const key in from) {
        const item = from[key]

        const newKey = key[0].toLowerCase() + key.slice(1)
        query[newKey] = item

        if (key === 'ProductId') {
          query.id = item
        }
      }

      const { data } = await this.$api.integral.add(query)
      console.log('修改状态', data)
    },

    changeC(e) {
      console.log('changeC', e)
      this.getList()
    },

    onEditInfo(data) {
      const url = `/order/goodsEdit?id=${data.ProductId || 0}`

      // if (data) {
      //   const dataInfo = {
      //     id: data.ProductId,
      //     name: data.Name,
      //     title: data.Title,
      //     price: data.Price,
      //     integral: data.Integral,
      //     freight: data.Freight,
      //     stock: data.Stock,
      //     maxCount: data.MaxCount,
      //     isIntegral: data.IsIntegral,
      //     ImgUrl: data.ImgUrl,
      //     content: data.Content,
      //     status: data.Status
      //   }

      //   url = `/order/goodsEdit?data=${JSON.stringify(dataInfo)}`
      // }

      this.$router.push(url)
    },

    async onDelete(id) {
      this.$confirm('是否删除该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await this.$api.integral.delete({
          id
        })
        console.log('删除产品', data)

        this.$message.success('删除成功')
        this.getList()
      })
    },

    onDeleteSpec(id) {
      this.$confirm('是否删除该规格?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await this.$api.integral.specDelete({
          id
        })
        console.log('删除规格', data)

        this.$message.success('删除成功')
        this.getList()
      })
    },

    onEditSpec(data) {
      console.log('onEditSpec', data)

      const obj = {}
      for (const key in data) {
        const newKey = key.charAt(0).toLocaleLowerCase() + key.slice(1)
        obj[newKey] = data[key]
      }

      this.addForm = {
        id: data.ProductSpecId,
        ...obj
      }
      console.log('addForm', this.addForm)

      this.addDialog = true
    },

    async loadSpec(tree, treeNode, resolve) {
      console.log('loadSpec', tree, treeNode, resolve)
      try {
        const { data } = await this.$api.integral.specList({
          productId: tree.ProductId
        })
        console.log('规格列表', data)
        resolve(data)
      } catch (error) {
        console.log(error)
      }
    },

    onAddSpec(productId) {
      this.initAddForm()
      this.addForm.productId = productId

      this.addDialog = true
    },

    async addDetermine() {
      console.log('addForm', this.addForm)

      const { data } = await this.$api.integral.addSpec(this.addForm)
      console.log('添加产品', data)

      this.addDialog = false
      this.initAddForm()
      this.getList()

      this.$message.success('添加成功')
    },

    addDialogClose() {
      this.initAddForm()

      this.addDialog = false
    },

    handleAvatarSuccess(res, file) {
      console.log(res)
      console.log(file)
      if (res.success) {
        this.addForm.imgUrl = res.data
        console.log(this.addForm)
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      console.log(file.url)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    imgClose() {
      this.dialogImageUrl = ''
      this.dialogVisible = false
    },

    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .data-list {
  width: 620px !important;

  ul.el-scrollbar__view {
    display: flex;
    flex-wrap: wrap;
  }
}

.auditImg {
  display: flex;
  .block {
    margin-right: 25px;
    span {
      display: block;
      width: 120px;
      text-align: center;
    }
    img {
      width: 120px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.pre_img {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999988;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 60px;
    top: 60px;
    font-size: 40px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
  }

  .img {
    width: 20%;
    display: block;
  }
}
</style>
